module.exports = __webpack_public_path__ + "static/media/handshake.547733c2.jpg";